/* Version: 3.5.155 */
'use client';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState, useCallback } from 'react';

function useToggle(initialValue) {
  var _useState = useState(initialValue),
    _useState2 = _slicedToArray(_useState, 2),
    toggleValue = _useState2[0],
    setToggleValue = _useState2[1];
  var toggler = useCallback(function () {
    return setToggleValue(!toggleValue);
  }, [toggleValue]);
  return [toggleValue, toggler, setToggleValue];
}

export { useToggle as default };
